import { Seller } from '@/types/Seller';
import { SellerCatalogCounts } from '@/types/SellerCatalogCounts';

export type SellerResponseData = {
    sellerCatalogCounts: SellerCatalogCounts[];
    sellers: Seller[];
};

export type SellerSlice = {
    byId: { [id: number]: Seller };
    loaded: { [id: number]: number };
    loadedSellers: boolean;
    loading: number[];
    loadingSellers: boolean;
};

export const defaultSellerSlice: SellerSlice = {
    byId: {},
    loaded: {},
    loadedSellers: false,
    loading: [],
    loadingSellers: false,
};
